import type { Notification } from '@doneverse/shared'
import { api } from '../api/index.js'

export const notificationService = {
  fetchNotifications: async (limit = 20, offset = 0) => {
    return api.query({ limit, offset }).get('/v1/notifications').json<Notification[]>()
  },

  markNotificationAsRead: async (notificationId: string) => {
    return api.post({}, `/v1/notifications/${notificationId}/read`).json<Notification>()
  },

  markAllNotificationsAsRead: async () => {
    return api.post({}, '/v1/notifications/read-all').json<{ success: boolean }>()
  },

  fetchUnreadCount: async () => {
    return api.get('/v1/notifications/unread/count').json<{ count: number }>()
  },
}
